import React, { Suspense, useEffect, useState } from 'react';

import './index.scss';

import { BrowserRouter, useLocation } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Routing } from 'pages';
import LoaderAnimate from 'shared/ui/LoaderAnimate/index';
import { AppContext } from 'shared/model/contexts/AppContext';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // default: true
    },
  },
});

function AppContent() {
  const { pathname } = useLocation();
  const [isHasOrders, setIsHasOrders] = useState(false);
  const [loadedRoutes, setLoadedRoutes] = useState(() => new Set());
  const isLoading = !loadedRoutes.has(pathname);

  useEffect(() => {
    if (loadedRoutes.has(pathname)) return undefined;

    const loaderTimer = setTimeout(() => {
      setLoadedRoutes((routes) => {
        const nextRoutes = new Set(routes);
        nextRoutes.add(pathname);
        return nextRoutes;
      });
    }, 300);

    return () => clearTimeout(loaderTimer);
  }, [loadedRoutes, pathname]);

  return (
    <>
      {isLoading && <LoaderAnimate />}
      <Suspense fallback={<LoaderAnimate />}>
        <AppContext.Provider value={{ isHasOrders, setIsHasOrders }}>
          <QueryClientProvider client={queryClient}>
            <div className="app">
              <Routing />
            </div>
          </QueryClientProvider>
        </AppContext.Provider>
      </Suspense>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
